import { ChatRoomResponse, ScenarioWithRoomsAndStages } from '../../common/types';

export const room: ChatRoomResponse = {
  members: [
    {
      userUuid: '215cd3fc-43a9-48f7-bea1-3ef52c10b8f4',
      name: 'Max',
    },
    {
      userUuid: 'c6838546-e090-4e55-ac5c-ba45510d3b2b',
      name: 'Bob',
    },
    {
      userUuid: '727c7296-538c-4a48-bfe0-a19a23b6010e',
      name: 'Alice',
    },
  ],
  messages: [
    {
      type: 'image',
      caption:
        'A dimly lit server room with racks of servers, blinking lights, and a central console displaying alerts.',
      uuid: 'da449964-1ea0-4a16-9b76-67cb7974617b',
      roomUuid: 'ded81049-9486-47d5-8b84-c9fb4d25d6eb',
      url: 'https://cdn.aiescape.io/events/b18e5cc1-c5f9-485c-a88f-b4b66875328b.png',
      author_type: 'system',
      createdAt: new Date('2024-10-15T01:44:03.240Z'),
    },
    {
      type: 'text',
      uuid: '1a93fa23-1149-44e2-ac70-747f5288da2d',
      roomUuid: 'ded81049-9486-47d5-8b84-c9fb4d25d6eb',
      content:
        "You find yourself in the heart of the company's server room. The air is filled with the hum of servers and the flicker of warning lights. A central console blares alerts about a potential network breach. Your task is to navigate through the digital landscape to identify and neutralize the threat. Look around, interact with the console, and find clues hidden among the cables and manuals to secure the network.",
      author_type: 'system',
      createdAt: new Date('2024-10-15T01:44:04.240Z'),
    },
    {
      type: 'text',
      uuid: '79684193-7978-4ccf-a61c-b49afe6fa827',
      roomUuid: 'ded81049-9486-47d5-8b84-c9fb4d25d6eb',
      content: 'read the console',
      author_type: 'user',
      user: {
        userUuid: '215cd3fc-43a9-48f7-bea1-3ef52c10b8f4',
        name: 'Max',
      },
      createdAt: new Date('2024-10-15T01:54:48.305Z'),
    },
    {
      type: 'text',
      uuid: '7fc53a8a-6149-405f-851e-13235a86d698',
      roomUuid: 'ded81049-9486-47d5-8b84-c9fb4d25d6eb',
      content:
        "You approach the central console, which is the focal point of the room. The screen is filled with a series of alerts and warnings, indicating a potential breach in the network. The interface is cluttered with various options and menus, but two main sections catch your attention:\n\n1. **Firewall Settings**: This section allows you to view and modify the firewall rules. It's crucial to ensure that only authorized traffic is allowed through.\n\n2. **Intrusion Detection Logs**: Here, you can analyze logs that record network activity. These logs contain timestamps, IP addresses, and actions, which can help you identify any suspicious activity.\n\nWhere would you like to start?",
      author_type: 'system',
      createdAt: new Date('2024-10-15T01:54:54.859Z'),
    },
    {
      type: 'text',
      uuid: '259508e8-586e-4336-ae7d-d177be7c1752',
      roomUuid: 'ded81049-9486-47d5-8b84-c9fb4d25d6eb',
      content: 'Check out the logs',
      author_type: 'user',
      user: {
        userUuid: 'c6838546-e090-4e55-ac5c-ba45510d3b2b',
        name: 'Bob',
      },
      createdAt: new Date('2024-10-15T01:56:25.943Z'),
    },
    {
      type: 'text',
      uuid: '370af9fa-0b57-4e9d-aa38-107b54ead2fb',
      roomUuid: 'ded81049-9486-47d5-8b84-c9fb4d25d6eb',
      content:
        'You navigate to the Intrusion Detection Logs section on the console. The screen displays a list of logs, each entry containing a timestamp, an IP address, and a description of the action taken. The logs are extensive, but you notice a few patterns that might indicate suspicious activity.\n\nAs you scroll through, you see multiple access attempts from various IP addresses. However, one IP address, in particular, seems to appear more frequently than others: **192.168.1.105**. The logs show repeated access attempts from this IP address, often at unusual times.\n\nWhat would you like to do next?',
      author_type: 'system',
      createdAt: new Date('2024-10-15T01:56:30.361Z'),
    },
    {
      type: 'text',
      uuid: '83fe09ac-3db5-4a06-9c9a-4b52dbc539c1',
      roomUuid: 'ded81049-9486-47d5-8b84-c9fb4d25d6eb',
      content: 'read the firewall data',
      author_type: 'user',
      user: {
        userUuid: '727c7296-538c-4a48-bfe0-a19a23b6010e',
        name: 'Alice',
      },
      createdAt: new Date('2024-10-15T02:05:44.767Z'),
    },
    {
      type: 'text',
      uuid: 'c5ec18fa-807e-4b39-9c68-b9606154ff20',
      roomUuid: 'ded81049-9486-47d5-8b84-c9fb4d25d6eb',
      content:
        'You switch over to the Firewall Settings section on the console. The screen displays a list of current firewall rules. Each rule specifies the type of traffic that is allowed or blocked, along with the relevant ports and protocols.\n\nAs you review the rules, you notice a few that seem outdated or potentially harmful. Some rules allow incoming traffic on ports that are not typically used for secure communications, and others seem redundant or unnecessary.\n\nThe task is to identify which rules need to be corrected to ensure that only authorized traffic is allowed through the firewall. You need to determine which rules are unnecessary or could potentially allow unauthorized access.\n\nWhat would you like to do next?',
      author_type: 'system',
      createdAt: new Date('2024-10-15T02:05:49.070Z'),
    },
    {
      type: 'text',
      uuid: '1f0921c2-6a02-4d78-afae-f4f6799125ce',
      roomUuid: 'ded81049-9486-47d5-8b84-c9fb4d25d6eb',
      content: 'read the rules',
      author_type: 'user',
      user: {
        userUuid: '215cd3fc-43a9-48f7-bea1-3ef52c10b8f4',
        name: 'Max',
      },
      createdAt: '2024-10-15T02:06:09.696Z',
    },
    {
      type: 'text',
      uuid: 'fa004cd0-a931-4dd7-8292-29ae15eaf61e',
      roomUuid: 'ded81049-9486-47d5-8b84-c9fb4d25d6eb',
      content:
        "You carefully examine the list of firewall rules displayed on the console. Here are some of the key entries you notice:\n\n1. **Allow Incoming Traffic on Port 21 (FTP)**\n2. **Allow Incoming Traffic on Port 23 (Telnet)**\n3. **Allow Incoming Traffic on Port 80 (HTTP)**\n4. **Allow Incoming Traffic on Port 443 (HTTPS)**\n5. **Allow Incoming Traffic on Port 3389 (RDP)**\n6. **Block All Incoming Traffic Except for Ports 80 and 443**\n7. **Allow Incoming Traffic on Port 110 (POP3)**\n8. **Allow Incoming Traffic on Port 25 (SMTP)**\n\nSome of these rules seem outdated or unnecessary, especially given the need for secure communications. You need to decide which rules should be removed or modified to enhance the network's security.\n\nWhat would you like to do next?",
      author_type: 'system',
      createdAt: new Date('2024-10-15T02:06:14.845Z'),
    },
    {
      type: 'text',
      uuid: 'd6d40263-7a32-4a0e-8e86-026c15530a21',
      roomUuid: 'ded81049-9486-47d5-8b84-c9fb4d25d6eb',
      content: 'Do we need any other services than web traffic?',
      author_type: 'user',
      user: {
        userUuid: 'c6838546-e090-4e55-ac5c-ba45510d3b2b',
        name: 'Bob',
      },
      createdAt: new Date('2024-10-15T02:07:15.170Z'),
    },
    {
      type: 'text',
      uuid: '227b4eff-2ce5-4a1e-824c-9b6e21b9c604',
      roomUuid: 'ded81049-9486-47d5-8b84-c9fb4d25d6eb',
      content:
        "In a typical secure network configuration, especially in a scenario where you're trying to mitigate a breach, it's generally advisable to limit incoming traffic to only essential services. For most web services, the essential ports are:\n\n- **Port 80 (HTTP)**: Used for standard web traffic.\n- **Port 443 (HTTPS)**: Used for secure web traffic.\n\nOther services, such as FTP (Port 21), Telnet (Port 23), RDP (Port 3389), POP3 (Port 110), and SMTP (Port 25), can pose security risks if not properly secured and are often not necessary for basic web operations.\n\nWould you like to make any changes to the firewall rules based on this information?",
      author_type: 'system',
      createdAt: new Date('2024-10-15T02:07:19.995Z'),
    },
    {
      type: 'text',
      uuid: 'f8a4a2b8-9db5-4465-9b53-118b21a6f84f',
      roomUuid: 'ded81049-9486-47d5-8b84-c9fb4d25d6eb',
      content: 'remove all rules except 6, so we only allow web traffic',
      author_type: 'user',
      user: {
        userUuid: '727c7296-538c-4a48-bfe0-a19a23b6010e',
        name: 'Alice',
      },
      createdAt: new Date('2024-10-15T02:07:43.394Z'),
    },
    {
      type: 'solved_puzzle',
      name: 'Firewall Configuration',
      content:
        "You have successfully updated the firewall configuration. By removing all rules except for the one that blocks all incoming traffic except for ports 80 and 443, you have ensured that only essential web traffic is allowed. This significantly enhances the network's security posture.",
      roomUuid: 'ded81049-9486-47d5-8b84-c9fb4d25d6eb',
      author_type: 'system',
      uuid: '131cc1db-8379-477b-a947-f3213ad5f75f',
      createdAt: new Date('2024-10-15T02:07:47.203Z'),
    },
    {
      type: 'text',
      uuid: '61aaaca0-307c-42c5-b558-041466d4ce53',
      roomUuid: 'ded81049-9486-47d5-8b84-c9fb4d25d6eb',
      content:
        'The firewall configuration has been successfully updated. Now, only web traffic on ports 80 and 443 is allowed, which should help in securing the network against unauthorized access.\n\nWould you like to continue investigating the intrusion detection logs or take any other actions?',
      author_type: 'system',
      createdAt: new Date('2024-10-15T02:07:50.402Z'),
    },
  ],
  loading: false,
  scenarioUuid: 'b57edcb2-f48f-4525-853f-43fc14c22ddf',
  eventUuid: '606eef1f-e222-4bf7-b529-4360b3794af8',
  size: 5,
  number: 3,
  uuid: 'ded81049-9486-47d5-8b84-c9fb4d25d6eb',
  stages: [
    {
      stageUuid: '19b28ab8-ed99-4d68-bbf3-35cf3f819c26',
      number: 1,
      name: 'Network Security Breach',
      puzzles: [
        {
          number: 1,
          puzzleUuid: '7bd82aca-45cb-4400-88ad-e5cd33b28cdb',
          name: 'Firewall Configuration',
          completedAt: new Date('2024-10-15T02:07:47.205Z'),
        },
        {
          number: 2,
          puzzleUuid: '4d0c1df1-a0df-4570-97d8-e0b7c3f3185e',
          name: 'Intrusion Detection System',
          completedAt: null,
        },
      ],
      startedAt: new Date('2024-10-15T01:44:03.240Z'),
      completedAt: null,
      nextStageUuid: '01c0c8c2-bc41-4e6f-92dc-d191f40f20aa',
    },
    {
      stageUuid: '01c0c8c2-bc41-4e6f-92dc-d191f40f20aa',
      number: 2,
      name: 'Data Protection Protocols',
      puzzles: [
        {
          number: 1,
          puzzleUuid: '8f110b52-1273-4148-91b9-105184ce1ec8',
          name: 'Encryption Key Management',
          completedAt: null,
        },
        {
          number: 2,
          puzzleUuid: '173c2446-6f12-4247-a47b-e4237bfb5477',
          name: 'Access Control Verification',
          completedAt: null,
        },
      ],
      startedAt: null,
      completedAt: null,
      nextStageUuid: '8fc3c933-aba8-41aa-989f-b5a3699d5c12',
    },
    {
      stageUuid: '8fc3c933-aba8-41aa-989f-b5a3699d5c12',
      number: 3,
      name: 'Incident Response and Recovery',
      puzzles: [
        {
          number: 1,
          puzzleUuid: '9685cad2-ed82-43c2-90a7-f5dedf62a793',
          name: 'Threat Analysis',
          completedAt: null,
        },
        {
          number: 2,
          puzzleUuid: '68ef8273-2e1a-416d-8802-88c076f0611f',
          name: 'System Recovery',
          completedAt: null,
        },
      ],
      startedAt: null,
      completedAt: null,
    },
  ],
};

export const scenario: ScenarioWithRoomsAndStages = {
  scenarioUuid: 'b57edcb2-f48f-4525-853f-43fc14c22ddf',
  name: 'Security Escape',
  description: "Learn about your company's cybersecurity posture.",
  image: 'https://cdn.aiescape.io/events/b18e5cc1-c5f9-485c-a88f-b4b66875328b.png',
  event: {
    eventUuid: '',
    name: 'Security Escape',
    code: '',
  },
  rooms: [
    {
      number: 1,
      uuid: 'ea921821-1070-4199-8023-b6dc7283a14e',
      size: 5,
      members: [],
      stages: [
        {
          stageUuid: '19b28ab8-ed99-4d68-bbf3-35cf3f819c26',
          number: 1,
          name: 'Network Security Breach',
          puzzles: [
            {
              id: 83,
              puzzleUuid: '7bd82aca-45cb-4400-88ad-e5cd33b28cdb',
              number: 1,
              name: 'Firewall Configuration',
              completedAt: null,
            },
            {
              id: 84,
              puzzleUuid: '4d0c1df1-a0df-4570-97d8-e0b7c3f3185e',
              number: 2,
              name: 'Intrusion Detection System',
              completedAt: null,
            },
          ],
          nextStageUuid: '01c0c8c2-bc41-4e6f-92dc-d191f40f20aa',
          startedAt: '2024-10-15T01:43:58.372Z',
          completedAt: null,
        },
        {
          stageUuid: '01c0c8c2-bc41-4e6f-92dc-d191f40f20aa',
          number: 2,
          name: 'Data Protection Protocols',
          puzzles: [
            {
              id: 85,
              puzzleUuid: '8f110b52-1273-4148-91b9-105184ce1ec8',
              number: 1,
              name: 'Encryption Key Management',
              completedAt: null,
            },
            {
              id: 86,
              puzzleUuid: '173c2446-6f12-4247-a47b-e4237bfb5477',
              number: 2,
              name: 'Access Control Verification',
              completedAt: null,
            },
          ],
          nextStageUuid: '8fc3c933-aba8-41aa-989f-b5a3699d5c12',
          startedAt: null,
          completedAt: null,
        },
        {
          stageUuid: '8fc3c933-aba8-41aa-989f-b5a3699d5c12',
          number: 3,
          name: 'Incident Response and Recovery',
          puzzles: [
            {
              id: 87,
              puzzleUuid: '9685cad2-ed82-43c2-90a7-f5dedf62a793',
              number: 1,
              name: 'Threat Analysis',
              completedAt: null,
            },
            {
              id: 88,
              puzzleUuid: '68ef8273-2e1a-416d-8802-88c076f0611f',
              number: 2,
              name: 'System Recovery',
              completedAt: null,
            },
          ],
          startedAt: null,
          completedAt: null,
        },
      ],
    },
    {
      number: 2,
      uuid: '9c32ab8a-40ea-462c-80c5-213e02945bb1',
      size: 5,
      members: [],
      stages: [
        {
          stageUuid: '19b28ab8-ed99-4d68-bbf3-35cf3f819c26',
          number: 1,
          name: 'Network Security Breach',
          puzzles: [
            {
              id: 83,
              puzzleUuid: '7bd82aca-45cb-4400-88ad-e5cd33b28cdb',
              number: 1,
              name: 'Firewall Configuration',
              completedAt: null,
            },
            {
              id: 84,
              puzzleUuid: '4d0c1df1-a0df-4570-97d8-e0b7c3f3185e',
              number: 2,
              name: 'Intrusion Detection System',
              completedAt: null,
            },
          ],
          nextStageUuid: '01c0c8c2-bc41-4e6f-92dc-d191f40f20aa',
          startedAt: '2024-10-15T01:44:01.987Z',
          completedAt: null,
        },
        {
          stageUuid: '01c0c8c2-bc41-4e6f-92dc-d191f40f20aa',
          number: 2,
          name: 'Data Protection Protocols',
          puzzles: [
            {
              id: 85,
              puzzleUuid: '8f110b52-1273-4148-91b9-105184ce1ec8',
              number: 1,
              name: 'Encryption Key Management',
              completedAt: null,
            },
            {
              id: 86,
              puzzleUuid: '173c2446-6f12-4247-a47b-e4237bfb5477',
              number: 2,
              name: 'Access Control Verification',
              completedAt: null,
            },
          ],
          nextStageUuid: '8fc3c933-aba8-41aa-989f-b5a3699d5c12',
          startedAt: null,
          completedAt: null,
        },
        {
          stageUuid: '8fc3c933-aba8-41aa-989f-b5a3699d5c12',
          number: 3,
          name: 'Incident Response and Recovery',
          puzzles: [
            {
              id: 87,
              puzzleUuid: '9685cad2-ed82-43c2-90a7-f5dedf62a793',
              number: 1,
              name: 'Threat Analysis',
              completedAt: null,
            },
            {
              id: 88,
              puzzleUuid: '68ef8273-2e1a-416d-8802-88c076f0611f',
              number: 2,
              name: 'System Recovery',
              completedAt: null,
            },
          ],
          startedAt: null,
          completedAt: null,
        },
      ],
    },
    {
      number: 3,
      uuid: 'ded81049-9486-47d5-8b84-c9fb4d25d6eb',
      size: 5,
      members: [
        {
          userUuid: '727c7296-538c-4a48-bfe0-a19a23b6010e',
          name: 'Alice',
        },
        {
          userUuid: 'c6838546-e090-4e55-ac5c-ba45510d3b2b',
          name: 'Bob',
        },
        {
          userUuid: '215cd3fc-43a9-48f7-bea1-3ef52c10b8f4',
          name: 'Max',
        },
        {
          userUuid: '9fc48369-d143-4387-87e3-bad5b553b2be',
          name: 'Max',
        },
      ],
      stages: [
        {
          stageUuid: '19b28ab8-ed99-4d68-bbf3-35cf3f819c26',
          number: 1,
          name: 'Network Security Breach',
          puzzles: [
            {
              id: 83,
              puzzleUuid: '7bd82aca-45cb-4400-88ad-e5cd33b28cdb',
              number: 1,
              name: 'Firewall Configuration',
              completedAt: '2024-10-15T02:07:47.205Z',
            },
            {
              id: 84,
              puzzleUuid: '4d0c1df1-a0df-4570-97d8-e0b7c3f3185e',
              number: 2,
              name: 'Intrusion Detection System',
              completedAt: null,
            },
          ],
          nextStageUuid: '01c0c8c2-bc41-4e6f-92dc-d191f40f20aa',
          startedAt: '2024-10-15T01:44:03.240Z',
          completedAt: null,
        },
        {
          stageUuid: '01c0c8c2-bc41-4e6f-92dc-d191f40f20aa',
          number: 2,
          name: 'Data Protection Protocols',
          puzzles: [
            {
              id: 85,
              puzzleUuid: '8f110b52-1273-4148-91b9-105184ce1ec8',
              number: 1,
              name: 'Encryption Key Management',
              completedAt: null,
            },
            {
              id: 86,
              puzzleUuid: '173c2446-6f12-4247-a47b-e4237bfb5477',
              number: 2,
              name: 'Access Control Verification',
              completedAt: null,
            },
          ],
          nextStageUuid: '8fc3c933-aba8-41aa-989f-b5a3699d5c12',
          startedAt: null,
          completedAt: null,
        },
        {
          stageUuid: '8fc3c933-aba8-41aa-989f-b5a3699d5c12',
          number: 3,
          name: 'Incident Response and Recovery',
          puzzles: [
            {
              id: 87,
              puzzleUuid: '9685cad2-ed82-43c2-90a7-f5dedf62a793',
              number: 1,
              name: 'Threat Analysis',
              completedAt: null,
            },
            {
              id: 88,
              puzzleUuid: '68ef8273-2e1a-416d-8802-88c076f0611f',
              number: 2,
              name: 'System Recovery',
              completedAt: null,
            },
          ],
          startedAt: null,
          completedAt: null,
        },
      ],
    },
    {
      number: 4,
      uuid: '9ae11a3b-815e-4c1a-8727-24276eb2771e',
      size: 5,
      members: [],
      stages: [
        {
          stageUuid: '19b28ab8-ed99-4d68-bbf3-35cf3f819c26',
          number: 1,
          name: 'Network Security Breach',
          puzzles: [
            {
              id: 83,
              puzzleUuid: '7bd82aca-45cb-4400-88ad-e5cd33b28cdb',
              number: 1,
              name: 'Firewall Configuration',
              completedAt: null,
            },
            {
              id: 84,
              puzzleUuid: '4d0c1df1-a0df-4570-97d8-e0b7c3f3185e',
              number: 2,
              name: 'Intrusion Detection System',
              completedAt: null,
            },
          ],
          nextStageUuid: '01c0c8c2-bc41-4e6f-92dc-d191f40f20aa',
          startedAt: '2024-10-15T01:44:04.450Z',
          completedAt: null,
        },
        {
          stageUuid: '01c0c8c2-bc41-4e6f-92dc-d191f40f20aa',
          number: 2,
          name: 'Data Protection Protocols',
          puzzles: [
            {
              id: 85,
              puzzleUuid: '8f110b52-1273-4148-91b9-105184ce1ec8',
              number: 1,
              name: 'Encryption Key Management',
              completedAt: null,
            },
            {
              id: 86,
              puzzleUuid: '173c2446-6f12-4247-a47b-e4237bfb5477',
              number: 2,
              name: 'Access Control Verification',
              completedAt: null,
            },
          ],
          nextStageUuid: '8fc3c933-aba8-41aa-989f-b5a3699d5c12',
          startedAt: null,
          completedAt: null,
        },
        {
          stageUuid: '8fc3c933-aba8-41aa-989f-b5a3699d5c12',
          number: 3,
          name: 'Incident Response and Recovery',
          puzzles: [
            {
              id: 87,
              puzzleUuid: '9685cad2-ed82-43c2-90a7-f5dedf62a793',
              number: 1,
              name: 'Threat Analysis',
              completedAt: null,
            },
            {
              id: 88,
              puzzleUuid: '68ef8273-2e1a-416d-8802-88c076f0611f',
              number: 2,
              name: 'System Recovery',
              completedAt: null,
            },
          ],
          startedAt: null,
          completedAt: null,
        },
      ],
    },
    {
      number: 5,
      uuid: 'cfb890a2-6dcf-4a7c-8462-d07bbea96e4b',
      size: 5,
      members: [],
      stages: [
        {
          stageUuid: '19b28ab8-ed99-4d68-bbf3-35cf3f819c26',
          number: 1,
          name: 'Network Security Breach',
          puzzles: [
            {
              id: 83,
              puzzleUuid: '7bd82aca-45cb-4400-88ad-e5cd33b28cdb',
              number: 1,
              name: 'Firewall Configuration',
              completedAt: null,
            },
            {
              id: 84,
              puzzleUuid: '4d0c1df1-a0df-4570-97d8-e0b7c3f3185e',
              number: 2,
              name: 'Intrusion Detection System',
              completedAt: null,
            },
          ],
          nextStageUuid: '01c0c8c2-bc41-4e6f-92dc-d191f40f20aa',
          startedAt: '2024-10-15T01:44:05.653Z',
          completedAt: null,
        },
        {
          stageUuid: '01c0c8c2-bc41-4e6f-92dc-d191f40f20aa',
          number: 2,
          name: 'Data Protection Protocols',
          puzzles: [
            {
              id: 85,
              puzzleUuid: '8f110b52-1273-4148-91b9-105184ce1ec8',
              number: 1,
              name: 'Encryption Key Management',
              completedAt: null,
            },
            {
              id: 86,
              puzzleUuid: '173c2446-6f12-4247-a47b-e4237bfb5477',
              number: 2,
              name: 'Access Control Verification',
              completedAt: null,
            },
          ],
          nextStageUuid: '8fc3c933-aba8-41aa-989f-b5a3699d5c12',
          startedAt: null,
          completedAt: null,
        },
        {
          stageUuid: '8fc3c933-aba8-41aa-989f-b5a3699d5c12',
          number: 3,
          name: 'Incident Response and Recovery',
          puzzles: [
            {
              id: 87,
              puzzleUuid: '9685cad2-ed82-43c2-90a7-f5dedf62a793',
              number: 1,
              name: 'Threat Analysis',
              completedAt: null,
            },
            {
              id: 88,
              puzzleUuid: '68ef8273-2e1a-416d-8802-88c076f0611f',
              number: 2,
              name: 'System Recovery',
              completedAt: null,
            },
          ],
          startedAt: null,
          completedAt: null,
        },
      ],
    },
    {
      number: 6,
      uuid: '7868485e-e6a7-41d9-981f-f9c1fee69909',
      size: 5,
      members: [],
      stages: [
        {
          stageUuid: '19b28ab8-ed99-4d68-bbf3-35cf3f819c26',
          number: 1,
          name: 'Network Security Breach',
          puzzles: [
            {
              id: 83,
              puzzleUuid: '7bd82aca-45cb-4400-88ad-e5cd33b28cdb',
              number: 1,
              name: 'Firewall Configuration',
              completedAt: null,
            },
            {
              id: 84,
              puzzleUuid: '4d0c1df1-a0df-4570-97d8-e0b7c3f3185e',
              number: 2,
              name: 'Intrusion Detection System',
              completedAt: null,
            },
          ],
          nextStageUuid: '01c0c8c2-bc41-4e6f-92dc-d191f40f20aa',
          startedAt: '2024-10-15T01:44:07.140Z',
          completedAt: null,
        },
        {
          stageUuid: '01c0c8c2-bc41-4e6f-92dc-d191f40f20aa',
          number: 2,
          name: 'Data Protection Protocols',
          puzzles: [
            {
              id: 85,
              puzzleUuid: '8f110b52-1273-4148-91b9-105184ce1ec8',
              number: 1,
              name: 'Encryption Key Management',
              completedAt: null,
            },
            {
              id: 86,
              puzzleUuid: '173c2446-6f12-4247-a47b-e4237bfb5477',
              number: 2,
              name: 'Access Control Verification',
              completedAt: null,
            },
          ],
          nextStageUuid: '8fc3c933-aba8-41aa-989f-b5a3699d5c12',
          startedAt: null,
          completedAt: null,
        },
        {
          stageUuid: '8fc3c933-aba8-41aa-989f-b5a3699d5c12',
          number: 3,
          name: 'Incident Response and Recovery',
          puzzles: [
            {
              id: 87,
              puzzleUuid: '9685cad2-ed82-43c2-90a7-f5dedf62a793',
              number: 1,
              name: 'Threat Analysis',
              completedAt: null,
            },
            {
              id: 88,
              puzzleUuid: '68ef8273-2e1a-416d-8802-88c076f0611f',
              number: 2,
              name: 'System Recovery',
              completedAt: null,
            },
          ],
          startedAt: null,
          completedAt: null,
        },
      ],
    },
    {
      number: 7,
      uuid: '7918e7cd-0eb7-4e2e-90b9-b06f15c7947e',
      size: 5,
      members: [],
      stages: [
        {
          stageUuid: '19b28ab8-ed99-4d68-bbf3-35cf3f819c26',
          number: 1,
          name: 'Network Security Breach',
          puzzles: [
            {
              id: 83,
              puzzleUuid: '7bd82aca-45cb-4400-88ad-e5cd33b28cdb',
              number: 1,
              name: 'Firewall Configuration',
              completedAt: null,
            },
            {
              id: 84,
              puzzleUuid: '4d0c1df1-a0df-4570-97d8-e0b7c3f3185e',
              number: 2,
              name: 'Intrusion Detection System',
              completedAt: null,
            },
          ],
          nextStageUuid: '01c0c8c2-bc41-4e6f-92dc-d191f40f20aa',
          startedAt: '2024-10-15T01:44:08.225Z',
          completedAt: null,
        },
        {
          stageUuid: '01c0c8c2-bc41-4e6f-92dc-d191f40f20aa',
          number: 2,
          name: 'Data Protection Protocols',
          puzzles: [
            {
              id: 85,
              puzzleUuid: '8f110b52-1273-4148-91b9-105184ce1ec8',
              number: 1,
              name: 'Encryption Key Management',
              completedAt: null,
            },
            {
              id: 86,
              puzzleUuid: '173c2446-6f12-4247-a47b-e4237bfb5477',
              number: 2,
              name: 'Access Control Verification',
              completedAt: null,
            },
          ],
          nextStageUuid: '8fc3c933-aba8-41aa-989f-b5a3699d5c12',
          startedAt: null,
          completedAt: null,
        },
        {
          stageUuid: '8fc3c933-aba8-41aa-989f-b5a3699d5c12',
          number: 3,
          name: 'Incident Response and Recovery',
          puzzles: [
            {
              id: 87,
              puzzleUuid: '9685cad2-ed82-43c2-90a7-f5dedf62a793',
              number: 1,
              name: 'Threat Analysis',
              completedAt: null,
            },
            {
              id: 88,
              puzzleUuid: '68ef8273-2e1a-416d-8802-88c076f0611f',
              number: 2,
              name: 'System Recovery',
              completedAt: null,
            },
          ],
          startedAt: null,
          completedAt: null,
        },
      ],
    },
    {
      number: 8,
      uuid: '684a3f45-35b4-41dd-bd50-ac148a8703f0',
      size: 5,
      members: [],
      stages: [
        {
          stageUuid: '19b28ab8-ed99-4d68-bbf3-35cf3f819c26',
          number: 1,
          name: 'Network Security Breach',
          puzzles: [
            {
              id: 83,
              puzzleUuid: '7bd82aca-45cb-4400-88ad-e5cd33b28cdb',
              number: 1,
              name: 'Firewall Configuration',
              completedAt: null,
            },
            {
              id: 84,
              puzzleUuid: '4d0c1df1-a0df-4570-97d8-e0b7c3f3185e',
              number: 2,
              name: 'Intrusion Detection System',
              completedAt: null,
            },
          ],
          nextStageUuid: '01c0c8c2-bc41-4e6f-92dc-d191f40f20aa',
          startedAt: '2024-10-15T01:44:09.325Z',
          completedAt: null,
        },
        {
          stageUuid: '01c0c8c2-bc41-4e6f-92dc-d191f40f20aa',
          number: 2,
          name: 'Data Protection Protocols',
          puzzles: [
            {
              id: 85,
              puzzleUuid: '8f110b52-1273-4148-91b9-105184ce1ec8',
              number: 1,
              name: 'Encryption Key Management',
              completedAt: null,
            },
            {
              id: 86,
              puzzleUuid: '173c2446-6f12-4247-a47b-e4237bfb5477',
              number: 2,
              name: 'Access Control Verification',
              completedAt: null,
            },
          ],
          nextStageUuid: '8fc3c933-aba8-41aa-989f-b5a3699d5c12',
          startedAt: null,
          completedAt: null,
        },
        {
          stageUuid: '8fc3c933-aba8-41aa-989f-b5a3699d5c12',
          number: 3,
          name: 'Incident Response and Recovery',
          puzzles: [
            {
              id: 87,
              puzzleUuid: '9685cad2-ed82-43c2-90a7-f5dedf62a793',
              number: 1,
              name: 'Threat Analysis',
              completedAt: null,
            },
            {
              id: 88,
              puzzleUuid: '68ef8273-2e1a-416d-8802-88c076f0611f',
              number: 2,
              name: 'System Recovery',
              completedAt: null,
            },
          ],
          startedAt: null,
          completedAt: null,
        },
      ],
    },
    {
      number: 9,
      uuid: '4860f6f1-e9e3-474f-a6bf-167bce74c59e',
      size: 5,
      members: [],
      stages: [
        {
          stageUuid: '19b28ab8-ed99-4d68-bbf3-35cf3f819c26',
          number: 1,
          name: 'Network Security Breach',
          puzzles: [
            {
              id: 83,
              puzzleUuid: '7bd82aca-45cb-4400-88ad-e5cd33b28cdb',
              number: 1,
              name: 'Firewall Configuration',
              completedAt: null,
            },
            {
              id: 84,
              puzzleUuid: '4d0c1df1-a0df-4570-97d8-e0b7c3f3185e',
              number: 2,
              name: 'Intrusion Detection System',
              completedAt: null,
            },
          ],
          nextStageUuid: '01c0c8c2-bc41-4e6f-92dc-d191f40f20aa',
          startedAt: '2024-10-15T01:44:10.414Z',
          completedAt: null,
        },
        {
          stageUuid: '01c0c8c2-bc41-4e6f-92dc-d191f40f20aa',
          number: 2,
          name: 'Data Protection Protocols',
          puzzles: [
            {
              id: 85,
              puzzleUuid: '8f110b52-1273-4148-91b9-105184ce1ec8',
              number: 1,
              name: 'Encryption Key Management',
              completedAt: null,
            },
            {
              id: 86,
              puzzleUuid: '173c2446-6f12-4247-a47b-e4237bfb5477',
              number: 2,
              name: 'Access Control Verification',
              completedAt: null,
            },
          ],
          nextStageUuid: '8fc3c933-aba8-41aa-989f-b5a3699d5c12',
          startedAt: null,
          completedAt: null,
        },
        {
          stageUuid: '8fc3c933-aba8-41aa-989f-b5a3699d5c12',
          number: 3,
          name: 'Incident Response and Recovery',
          puzzles: [
            {
              id: 87,
              puzzleUuid: '9685cad2-ed82-43c2-90a7-f5dedf62a793',
              number: 1,
              name: 'Threat Analysis',
              completedAt: null,
            },
            {
              id: 88,
              puzzleUuid: '68ef8273-2e1a-416d-8802-88c076f0611f',
              number: 2,
              name: 'System Recovery',
              completedAt: null,
            },
          ],
          startedAt: null,
          completedAt: null,
        },
      ],
    },
    {
      number: 10,
      uuid: '830db9d3-600d-4f65-b40c-45ddcca2c03f',
      size: 5,
      members: [],
      stages: [
        {
          stageUuid: '19b28ab8-ed99-4d68-bbf3-35cf3f819c26',
          number: 1,
          name: 'Network Security Breach',
          puzzles: [
            {
              id: 83,
              puzzleUuid: '7bd82aca-45cb-4400-88ad-e5cd33b28cdb',
              number: 1,
              name: 'Firewall Configuration',
              completedAt: null,
            },
            {
              id: 84,
              puzzleUuid: '4d0c1df1-a0df-4570-97d8-e0b7c3f3185e',
              number: 2,
              name: 'Intrusion Detection System',
              completedAt: null,
            },
          ],
          nextStageUuid: '01c0c8c2-bc41-4e6f-92dc-d191f40f20aa',
          startedAt: '2024-10-15T01:44:11.434Z',
          completedAt: null,
        },
        {
          stageUuid: '01c0c8c2-bc41-4e6f-92dc-d191f40f20aa',
          number: 2,
          name: 'Data Protection Protocols',
          puzzles: [
            {
              id: 85,
              puzzleUuid: '8f110b52-1273-4148-91b9-105184ce1ec8',
              number: 1,
              name: 'Encryption Key Management',
              completedAt: null,
            },
            {
              id: 86,
              puzzleUuid: '173c2446-6f12-4247-a47b-e4237bfb5477',
              number: 2,
              name: 'Access Control Verification',
              completedAt: null,
            },
          ],
          nextStageUuid: '8fc3c933-aba8-41aa-989f-b5a3699d5c12',
          startedAt: null,
          completedAt: null,
        },
        {
          stageUuid: '8fc3c933-aba8-41aa-989f-b5a3699d5c12',
          number: 3,
          name: 'Incident Response and Recovery',
          puzzles: [
            {
              id: 87,
              puzzleUuid: '9685cad2-ed82-43c2-90a7-f5dedf62a793',
              number: 1,
              name: 'Threat Analysis',
              completedAt: null,
            },
            {
              id: 88,
              puzzleUuid: '68ef8273-2e1a-416d-8802-88c076f0611f',
              number: 2,
              name: 'System Recovery',
              completedAt: null,
            },
          ],
          startedAt: null,
          completedAt: null,
        },
      ],
    },
  ],
  stages: [
    {
      stageUuid: '19b28ab8-ed99-4d68-bbf3-35cf3f819c26',
      number: 1,
      name: 'Network Security Breach',
      puzzles: [
        {
          puzzleUuid: '7bd82aca-45cb-4400-88ad-e5cd33b28cdb',
          number: 1,
          name: 'Firewall Configuration',
        },
        {
          puzzleUuid: '4d0c1df1-a0df-4570-97d8-e0b7c3f3185e',
          number: 2,
          name: 'Intrusion Detection System',
        },
      ],
      nextStageUuid: '01c0c8c2-bc41-4e6f-92dc-d191f40f20aa',
    },
    {
      stageUuid: '01c0c8c2-bc41-4e6f-92dc-d191f40f20aa',
      number: 2,
      name: 'Data Protection Protocols',
      puzzles: [
        {
          puzzleUuid: '8f110b52-1273-4148-91b9-105184ce1ec8',
          number: 1,
          name: 'Encryption Key Management',
        },
        {
          puzzleUuid: '173c2446-6f12-4247-a47b-e4237bfb5477',
          number: 2,
          name: 'Access Control Verification',
        },
      ],
      nextStageUuid: '8fc3c933-aba8-41aa-989f-b5a3699d5c12',
    },
    {
      stageUuid: '8fc3c933-aba8-41aa-989f-b5a3699d5c12',
      number: 3,
      name: 'Incident Response and Recovery',
      puzzles: [
        {
          puzzleUuid: '9685cad2-ed82-43c2-90a7-f5dedf62a793',
          number: 1,
          name: 'Threat Analysis',
        },
        {
          puzzleUuid: '68ef8273-2e1a-416d-8802-88c076f0611f',
          number: 2,
          name: 'System Recovery',
        },
      ],
    },
  ],
  createdAt: '2024-10-15T01:43:15.483Z',
  difficulty: 'medium',
  caption:
    'A dimly lit server room with racks of servers, blinking lights, and a central console displaying alerts.',
};
